import React from 'react';

const EditProfile = () => {
  return (
    <div className="min-h-screen bg-secondary-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="card p-6">
          <h1 className="text-3xl font-bold text-secondary-900 mb-4">
            Edit Profile
          </h1>
          <p className="text-secondary-600">
            Edit profile functionality is under development.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
